import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import PermissionCheck from '@components/permissionCheck/PermissionCheck';

function Routes({ routeData, rootPath, currentSubmoduleName }) {
  const routes = useMemo(
    () =>
      routeData.map((route) => {
        const {
          path: _path,
          exact,
          render,
          main: Comp,
          visitor,
          ...rest
        } = route;
        const path = `${rootPath}${_path}`;
        // let RouteComp = AuthRoute;
        //
        // if (visitor) {
        //   RouteComp = Route;
        // }
        return (
          <Route
            key={path}
            path={path}
            exact={exact || false}
            render={(props) => (
              <PermissionCheck {...rest}>
                {render ? (
                  render({
                    ...props,
                    ...rest,
                  })
                ) : (
                  <Comp
                    {...props}
                    {...rest}
                    currentSubmoduleName={currentSubmoduleName}
                  />
                )}
              </PermissionCheck>
            )}
          />
        );
      }),
    [routeData, rootPath, currentSubmoduleName],
  );

  return <Switch>{routes}</Switch>;
}

Routes.defaultProps = {
  routeData: [],
  rootPath: '',
};

Routes.propTypes = {
  routeData: PropTypes.array,
  rootPath: PropTypes.string,
};

export default Routes;
